import CountUp from "react-countup";

const MediaScrolls = ({ visitas }) => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 text-center">
      <p className="text-sm text-gray-500">Total de Visitas</p>
      <p className="text-2xl font-bold text-pink-600">
        <CountUp end={isNaN(visitas) ? 0 : visitas} duration={1.5} />
      </p>
    </div>
  );
};

export default MediaScrolls;
